import AuthApi from '@apis/auth/AuthApi';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import SignInContext from '../context/SignInContext';

interface Props {
    smsAuthNo: string,
}

function useVerification({
  smsAuthNo,
}: Props) {
  const { usePhoneNo, useVerified } = useContext(SignInContext);
  const projectId = useProjectId();
  const [certPhoneNo] = usePhoneNo;
  const [_, setIsVerified] = useVerified;
  const toast = useToast();
  const { mutate } = useMutation({
    mutationKey: ['verifySms', certPhoneNo, smsAuthNo, projectId],
    mutationFn: () => AuthApi.verifySms({
      phoneNo: certPhoneNo,
      smsAuthNo,
      projectId,
    }),
    onSuccess() {
      setIsVerified(true);
      toast.success('인증이 완료되었습니다.');
    },
    onError() {
      toast.error('인증에 실패했습니다.');
    },
  });
  return () => {
    if (certPhoneNo) {
      mutate();
    }
  };
}

export default useVerification;
